export default __webpack_public_path__ + "static/media/toa-heftiba-7JaOPU9FrJA-unsplash.96312240.jpg";